// extracted by mini-css-extract-plugin
module.exports = {"groupLabel":"U1GsJE","mainWrapper":"hRIIWD","radioWrapper":"tKpehJ","input":"wOPWaC","active":"OK554N","label":"V4w8ly"};